import cn from "classnames";

// comonents
import DisplayValue from "../DisplayValue";

// store
import { ProfileService, useSearchStore } from "store/searchStore";

// styles
import styles from "./ServiceInformationSection.module.scss";

export default function ServiceInformationSection() {
  const { business_profile } = useSearchStore();

  const tableClasses = cn(
    "usa-table usa-table--borderless",
    styles["bonding-table"]
  );

  const anyQAS =
    business_profile?.qas_ansi_boolean ||
    business_profile?.qas_iso_9000_boolean ||
    business_profile?.qa_iso_10012_boolean ||
    business_profile?.qas_mil_q_boolean ||
    business_profile?.qas_mil_std_boolean;

  const specialEquiments =
    business_profile?.special_equip_material === "n/a"
      ? null
      : business_profile?.special_equip_material;

  const isBondingLvlEmpty =
    !business_profile?.construction_bonding_aggregate &&
    !business_profile?.construction_bonding_per_contract &&
    !business_profile?.service_bonding_contract &&
    !business_profile?.service_bonding_aggregate;

  return (
    <div className={styles["service-information-root"]}>
      <h2 className={styles["heading"]} id="service-information" tabIndex={-1}>
        Service information
      </h2>

      <div className={styles["content-section"]}>
        <div>
          <h5 className={styles["label"]}>Keywords</h5>
          <div className={styles["keywords"]}>
            {business_profile.keywords.length > 0 ? (
              business_profile.keywords.map((keyword, index) => (
                <span key={index} className={styles["tag"]}>
                  {keyword}
                </span>
              ))
            ) : (
              <span className={styles["not-provided"]}>Not Provided</span>
            )}
          </div>
        </div>

        <div>
          <h5 className={styles["label"]}>Special equipment/materials</h5>
          <DisplayValue
            messageElement="p"
            className={styles["value"]}
            errorClassName={styles["value"]}
            value={specialEquiments}
            message="Not Provided"
          />
        </div>

        <div>
          <h5 className={styles["label"]}>Bonding levels</h5>

          {!isBondingLvlEmpty && (
            <table className={tableClasses}>
              <tbody>
                <tr>
                  <td scope="row">Construction Bonding Level (per contract)</td>
                  <DisplayValue
                    messageElement="td"
                    value={Number(
                      business_profile?.construction_bonding_per_contract
                    )?.toLocaleString("en-US")}
                    prefix="$"
                    message="$0"
                  />
                </tr>
                <tr>
                  <td scope="row">Construction Bonding Level (aggregate)</td>
                  <DisplayValue
                    messageElement="td"
                    value={Number(
                      business_profile?.construction_bonding_aggregate
                    )?.toLocaleString("en-US")}
                    prefix="$"
                    message="$0"
                  />
                </tr>
                <tr>
                  <td scope="row">Service Bonding Level (per contract)</td>
                  <DisplayValue
                    messageElement="td"
                    value={Number(
                      business_profile?.service_bonding_contract
                    )?.toLocaleString("en-US")}
                    prefix="$"
                    message="$0"
                  />
                </tr>
                <tr>
                  <td scope="row">Service Bonding Level (aggregate)</td>
                  <DisplayValue
                    messageElement="td"
                    value={Number(
                      business_profile?.service_bonding_aggregate
                    )?.toLocaleString("en-US")}
                    prefix="$"
                    message="$0"
                  />
                </tr>
              </tbody>
            </table>
          )}

          {isBondingLvlEmpty && (
            <p className={styles["value"]}>
              <em>Not Provided</em>
            </p>
          )}
        </div>

        <div>
          <h5 className={styles["label"]}>Quality assurance standards</h5>
          <p className={styles["value"]}>
            {business_profile.qas_standards.length > 0 ? (
              <ul className={styles["list"]}>
                {business_profile.qas_standards.map((qas, index) => (
                  <li key={index}>{qas}</li>
                ))}
              </ul>
            ) : (
              <em>Not Provided</em>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
